import React from "react"
import clsx from "clsx"
import { useTranslation } from "react-i18next"

import classes from "./InventoryTableHeader.module.scss"

const InventoryTableHeader = () => {
  const [t, i18n] = useTranslation()

  const isLtr = i18n.dir(i18n.language) === "ltr"

  return (
    <thead>
      <tr>
        <th
          className={clsx(
            classes["headerItem"],
            classes["code"],
            isLtr && classes["headerItem-ltr"],
          )}
        >
          {t("کد_کالا")}
        </th>
        <th
          className={clsx(
            classes["headerItem"],
            classes["name"],
            isLtr && classes["headerItem-ltr"],
          )}
        >
          {t("اسم")}
        </th>
        <th
          className={clsx(
            classes["headerItem"],
            classes["stockManagement"],
            isLtr && classes["headerItem-ltr"],
          )}
        >
          {t("مدیریت_انبار")}
        </th>
        <th
          className={clsx(
            classes["headerItem"],
            classes["outOfStock"],
            isLtr && classes["headerItem-ltr"],
          )}
        >
          {t("ناموجود")}
        </th>
        <th
          className={clsx(
            classes["headerItem"],
            classes["inventory"],
            isLtr && classes["headerItem-ltr"],
          )}
        >
          {t("فهرست_موجودی")}
        </th>
      </tr>
    </thead>
  )
}

export default InventoryTableHeader